import React from 'react';
import { FaGlobe } from 'react-icons/fa';

const FooterWebsiteLink = () => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      textAlign: "center",
      padding: "15px",
      backgroundColor: "#f9f9f9"
    }}>
      <a
        href="https://anantainfotech.com/"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textDecoration: "none",
          gap: "10px",
          color: "#e65c2a"
        }}
      >
        <img
          src="https://res.cloudinary.com/ddkyeuhk8/image/upload/v1744867815/anantainfotech/ff8b3ol8tddtfgxvvgsw.png" // update the path based on your actual logo location
          alt="Ananta Infotech Logo"
          style={{ height: "30px", width: "auto", objectFit: "contain" }}
        />
        <FaGlobe size={24} color="#e65c2a" />
        <h4 style={{ margin: 0 }}>anantainfotech.com</h4>
      </a>
    </div>
  );
};

export default FooterWebsiteLink;
